import pet1 from '@/assets/images/dogs/review-avatars/pet-1.png';
import pet2 from '@/assets/images/dogs/review-avatars/pet-2.png';
import pet3 from '@/assets/images/dogs/review-avatars/pet-3.png';
import pet4 from '@/assets/images/dogs/review-avatars/pet-4.png';
import pet5 from '@/assets/images/dogs/review-avatars/pet-5.png';
import pet6 from '@/assets/images/dogs/review-avatars/pet-6.png';
import pet7 from '@/assets/images/dogs/review-avatars/pet-7.png';
import pet8 from '@/assets/images/dogs/review-avatars/pet-8.png';
import pet9 from '@/assets/images/dogs/review-avatars/pet-9.png';
import pet10 from '@/assets/images/dogs/review-avatars/pet-10.png';
import pet11 from '@/assets/images/dogs/review-avatars/pet-11.png';
import pet12 from '@/assets/images/dogs/review-avatars/pet-12.png';
export default [{
  rating: 5,
  name: 'Paige E',
  gender: 'F',
  review: 'Morgan was amazing with my two beagles and cat! They absolutely adored her. When I got home, they were calm, happy, and clearly well cared for. It was obvious Morgan gave them lots of love and attention. I felt totally at ease knowing they were in such good hands!',
  src: pet1
}, {
  rating: 5,
  name: 'Isabelle M',
  gender: 'F',
  review: 'Can\'t begin to say how appreciative we are of the care Bo received from Molly at her home while we were away for several days. He got lots of love, walks, and playtime. Thanks soo much!',
  src: pet2
}, {
  rating: 5,
  name: 'Alexandra S',
  gender: 'F',
  review: 'Thanks so much, Jack! Looks like you both had fun (I love the pic!), and my mom said she was so excited to meet you and had a great time. :) Jack was so good with her and gave her just the play and exercise she needed during my long work shift! Looking forward to next time!',
  src: pet10
}, {
  rating: 5,
  name: 'Samantha Q',
  gender: 'F',
  review: 'Nina has been excellent. We were in town to work for 10 days and we used Nina 9/10 days. She is awesome with our older dog Cricket. I recommend anyone in the Coral Gables area to call on Nina. You will not be disappointed!! Thank you Nina!',
  src: pet12
}, {
  rating: 5,
  name: 'Natalia B',
  gender: 'F',
  review: 'The pups looked so happy going on their walk, and the walk summary was fantastic - thank you for taking care of them!',
  src: pet11
}, {
  rating: 5,
  name: 'Max W',
  gender: 'M',
  review: 'Teagan made our first boarding experience amazing. She gave me updates and sent photos of my boys so they didn t feel so far away. She\'s super sweet and laid back. She even made an effort to come over and meet the boys before our trip so me and the dogs felt comfortable. Would definitely recommend her to anyone needing services.',
  src: pet3
}, {
  rating: 5,
  name: 'Arianna G',
  gender: 'F',
  review: 'She took care of my dog very well! She was on time; very respectful and responsible. The dog was happy!',
  src: pet4
}, {
  rating: 5,
  name: 'Jose R',
  gender: 'M',
  review: 'Steven is the best. Intuitive, reliable, and caring. He truly goes above and beyond, very grateful to have been connected with him!',
  src: pet5
}, {
  rating: 5,
  name: 'Lily B',
  gender: 'F',
  review: 'My dog received great attention and exercise! John understood his personality and gave him exactly what he needed. He also was excellent at communicating and sending pics. You can tell he is an animal lover and great guy in general. Bear came home tired and happy!! Highly recommend & will definitely book again!',
  src: pet7
}, {
  rating: 5,
  name: 'Joseph S',
  gender: 'M',
  review: 'Adam was great! took great care of our cat for 3 days and was very communicative and caring.',
  src: pet9
}, {
  rating: 5,
  name: 'Shin Y',
  gender: 'M',
  review: 'Alex, you\'re the best, me and my lil guys can\'t wait to have you back!',
  src: pet6
}, {
  rating: 5,
  name: 'Becky G',
  gender: 'F',
  review: 'Breanna did a great job walking my pup, would be happy to have her as a caregiver again!',
  src: pet8
}];